<template>
    <div class="page-group">
        <slot />
    </div>
</template>

<script>
    export default {
        name: 'PageGroup'
    };
</script>

<style lang="scss" scoped>
    @import 'source/stylesheets/sass/abstract/bpo-variables.scss';

    .page-group {
        @include scrollbar;
        display: grid;
        height: calc(100vh - 88px); // viewport height - (navbar height + breadcrumbs height)
        overflow: auto;

        @media #{$desktop-small} {
            height: calc(100vh - 48px); // viewport height - navbar height
        }
    }
</style>
